/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    ENERGYPERFORMANCE: 'Ahorro de energía',
    UTILITYBILLSAVINGS: 'Cargos de factura de servicios públicos',
    DateFrom: 'Fecha desde',
    SITES: 'Sitios',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Puntuación de la gestión energética',
    BASELINE: 'Línea base',
    BASELINEKEY: 'Línea base de consumo',
    ACTUALKEY: 'Consumo Actual',
    SAVINGS: 'Ahorro',
    ACTUAL: 'Actual',
    ACTUALEMISSIONS: 'Emisiones reales',
    ACTUALEMIS: 'Emis. actuales',
    PREVIOUSEMIS: 'Emis. anteriores',
    PREVIOUSEMISSIONS: 'Emisiones Anteriores',
    TOTALCONSUMPTION: 'Consumo total',
    ACTUALAVOIDANCE: 'Emisiones actuales evitadas',
    EMISSION: 'Emisiones',
    PREVIOUSPERIOD: 'Periodo anterior',
    PREVIOUS: 'Anterior',
    PREVIOUSAVOIDANCE: 'Evasión previa',
    ACTUALCOST: 'Coste actual',
    actualCost: 'CONS. ACTUAL',
    BASELINECOST: 'Coste de referencia',
    baselineCost: 'CONS. DE REFERENCIA',
    PREVSPER: 'PERÍODO ANTERIOR',
    PREVIOUSCOST: 'Coste anterior',
    VIEWDETAILS: 'VER DETALLES',
    ADVANCED: 'Avanzado',
    BASIC: 'Básico',
    LIVEMETER: 'Contadores in situ',
    UTILITYMETER: 'Contadores de servicios públicos',
    LIVEREADING: 'Contadores in situ',
    UTILITYINTERVAL: 'Intervalo de facturación',
    UTILITYPROVIDERNEW: 'Facturación mensual',
    ACTUALCONSUMPTION: 'Consumo actual',
    BASELINECONSUMPTION: 'Línea base de consumo',
    PREDICTED: 'Previsión',
    Utilitycost: 'Coste de la factura',
    UtilityBill: 'Resumen de la factura',
    UtilityCost: 'Coste de la factura',
    ActualCost: 'Coste actual',
    CostPercentage: 'Coste %',
    Electricity: 'Electricidad',
    Gas: 'Gas',
    Water: 'Agua',
    UtilityType: 'Tipo de servicio',
    all: 'todos',
    electricity: 'electricidad',
    gas: 'gas',
    water: 'agua',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Se han generado facturas de consumo de energía para {siteWithDataCount} de {totalSiteCount} sitios.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Se han generado emisiones para facturas de servicios públicos para {siteWithDataCount} de {totalSiteCount} sitios.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Se han generado emisiones para lecturas en directo para {siteWithDataCount} de {totalSiteCount} sitios.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Se han generado los consumos de energía de las facturas de servicios públicos para {siteWithDataCount} de {totalSiteCount} sitios.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Se han generado lecturas en directo para {siteWithDataCount} de {totalSiteCount} sitios.',
    UtilityTypeforselectutility: 'Tipo de servicio*',
    CONVERSIONINFOMSG:
      'Proporcione sus credenciales para permitir la conversión de este número de cuenta de un tipo de integración «Manual» a «Automático». Una vez verificadas las credenciales se verifiquen, el tipo de integración se actualizará automáticamente. Los datos guardados manualmente permanecerían y las próximas facturas se actualizarán automáticamente».',
    CO2: 'CO2',
    CARBON: 'Carbono({unit})',
    CARBONNOUNIT: 'Carbono',
    CARBONEMISSION: 'Emisiones de carbono',
    METERDATA1: 'Datos del contador',
    DATANEEDED: 'Datos necesarios',
    METERDATA: 'Datos del contador',
    METERDATASUBTITLE:
      'Analiza y compara el consumo del contador cargando datos históricos y/o de los periodos que faltan.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'CONSUMO DE ELECTRICIDAD',
    ELECTRICITYPERFORMANCE: 'Rendimiento eléctrico',
    Electicity:
      'Datos de Electricidad, Gas, Agua pueden ser integrados con la vinculación de sus cuentas',
    FORECAST: 'Previsión',
    ALL: 'Todos',
    ELECTRICITY: 'Electricidad',
    GAS: 'Gas',
    WATER: 'Agua',
    METER: 'CONTADOR',
    SavingMeter: 'Ahorro por contador',
    BREAKDOWNMETER: 'Cons. por Contadores',
    BREAKDOWNBYAREAS: 'Desglose por areas',
    BREAKDOWNBYEQUIPMENTTYPE: 'Desglose por tipo de equipo',
    CONSUMPTIONBYUTILITIES: 'Cons. por Utilidades',
    ENERGYBREAKDOWNOFUTILITY: 'Desglose por compañía eléctrica',
    ENERGYBREAKDOWNBYMETERS: 'Desglose por contadores',
    WATERBREAKDOWNBYLIVEMETERS: 'Desglose por contadores activos',
    BREAKDOWNOFUTILITY: 'Desglose de las tarifas de servicios públicos',
    breakdownUtility: 'Desglose por servicios públicos',
    breakdownCarbon: 'Desglose de contadores',
    breakdownCarbonScopeOne: 'Desglose por categoría',
    breakdownFuel: 'Desglose por tipos de combustible',
    breakdownAreas: 'Desglose por areas',
    areasHeader: 'Áreas',
    metersHeader: 'Contadores',
    areasSubHeaders:
      'El siguiente desglose del consumo eléctrico se realiza por áreas y para la duración seleccionada.',
    baselinebutton: 'Línea de base',
    LAST_BASELINE_TRAINED_DATE: 'Última línea de base formada en',
    apply: 'Aplicar',
    back: 'Volver',
    baselinetraning: 'Formación de línea de base',
    chooseTrainingDateRange: 'Elija el intervalo de fechas de entrenamiento',
    applyBaselineFrom: 'Aplicar línea de base desde',
    historicDataTooltip:
      'Para los datos históricos cargados, la línea de base será visible durante los últimos 15 días en el panel de control y en los informes.',
    excludeSpecificDateRangeQ:
      '¿Prefiere excluir un intervalo de fechas específico?',
    excludeDateRange: 'Excluir intervalo de fechas',
    howitworks: '¿Cómo funciona?',
    howitworksone:
      'Todos los datos de contadores cargados se utilizarán para entrenar un modelo de referencia de buena calidad.',
    howitworkstwo:
      'Los datos de referencia se mostrarán en el panel de control y en los informes de los últimos 15 días a partir de la fecha de carga.',
    howitworksthree:
      'Para obtener los mejores resultados de referencia, se recomienda disponer de 12 meses de datos.',
    howitworksfour:
      'Se necesitan como mínimo 30 días de datos para el entrenamiento del modelo',
    howitworksfive:
      'El entrenamiento de la línea de base se aplica a los datos de todos los contadores del sitio',
    howitworkssix:
      'Cuando se vuelve a entrenar el modelo de referencia, el modelo existente se sustituye en función del nuevo periodo de entrenamiento de referencia.',
    baselinedaterangeheader: 'Seleccione el periodo de entrenamiento inicial',
    baselinedaterangesubheader:
      'Seleccione el intervalo de fechas para el modelo base, si desea incluir o excluir un periodo específico.',
    redirectmsg1: 'Será redirigido en',
    redirectmsg2: 'seg.',
    uploadingmsg:
      'Por favor, espere mientras iniciamos el proceso para entrenar la línea de base, y le notificaremos por correo electrónico una vez que se haya completado.',
    meterSubHeaders:
      'La tabla proporciona un desglose de los contadores del emplazamiento junto con varios KPI.',
    breakdownCarbonSites: 'Emisiones de carbono por centros ({count})',
    ENERGYUSAGE: 'Consumo de energía',
    ENERGYUSAGECONSUMPTION: 'Consumo',
    USAGEConsumption: 'Consumo',
    WATERUSAGE: 'Consumo de agua',
    NILMTOOLTIPHEADER: 'Control de carga no intrusivo (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Desagregación energética',
    ENERGYUSAGEOVERVIEW: 'Visión general del uso de la energía',
    CONSUMPTIONOVERVIEW: 'Visión general del consumo',
    LOADING: 'Cargando',
    SUBMITTING: 'Enviando',
    NODATAAVAILABLE: 'No hay datos para el periodo de fechas seleccionado',
    UTILITYYEAROUTOFRANGE: 'Seleccione un intervalo de fechas dentro de un año',
    NOTSUBSCRIBED: 'No suscrito',
    CONNECTIONERROR:
      'No hemos podido conectarnos al servicio. Por favor, inténtelo de nuevo',
    CONNECTIONERRORTITLE: '¡Error de conexión!',
    WATERTOOLTIPHEADER: 'Consumo de agua',
    CARBONSAVINGSMETERHEADER: 'Emisiones por categoría',
    CARBONKPIDETAILS: 'Emisiones de carbono por',
    ENERGYUSAGEDETAILS: 'Consumo de energía para',
    WATERUSAGEDETAILS: 'Consumo de agua por',
    CarbonSavingMeter: 'Ahorro por servicio',
    SITENAMESHEADER: 'Desglose por sitios',
    CARBONTOOLTIPHEADER: 'Emisiones de carbono',
    GASTOOLTIPHEADER: 'Ahorro de energía en gas',
    ALLTOOLTIPHEADER: 'Ahorro de energía',
    METEROVERVIEW: 'Resumen de contadores',
    METERANALYSIS: 'Análisis de contadores',
    ID: 'ID',
    TYPE: 'Tipo',
    DEVIATION: 'Desviación',
    HIGH: 'Alto({unit})',
    HIGHWITHOUTUNIT: 'Alto',
    LOW: 'Bajo({unit})',
    LOWWITHNOUNIT: 'Bajo',
    ENERGY: 'Energía({unit})',
    ENERGYNOUNIT: 'Energía',
    CHANGE: 'Cambio',
    CARBONTAB: 'Carbono (CO2e)',
    ENERGYTAB: 'Energía',
    WATERTAB: 'Agua',
    EUITAB: 'EUI',
    UTILITYCOST: 'Servicio',
    actualConsumption: 'CONSUMO ACTUAL',
    actualCons: 'CONSUMO ACTUAL',
    baselineConsumption: 'CONSUMO DE REFERENCIA',
    baselineCons: 'CONS. BASE',
    ConsumptionSavingsPercentage: '% CONS. AHORRO',
    ConsumptionChange: 'CONS. CAMBIO',
    ConsSavings: 'CONS. AHORRO',
    utiltactualCost: 'COSTE ACTUAL',
    utilpreviousCost: 'COSTE ANTERIOR',
    SavingsPercentage: '% AHORRO',
    utilchange: 'CAMBIO',
    NODATA: 'Sin datos',
    ENERGYKPIDETAILS: 'Rendimiento eléctrico para',
    ENERGYPERFORMANCEALL: 'Rendimiento energético',
    NILMENERGYUSAGE: 'Consumo de energía',
    NILMENERGYUSAGESUBHEADER:
      'El gráfico muestra el consumo de energía durante el periodo seleccionado',
    ALLKPICARDDETAILS: 'Rendimiento energético para',
    WATERCONSUMPTIOND: 'Consumo de agua para',
    ENERGYCONSUMPTIONMETER: 'Consumo por contador',
    WATERCONSUMPTION: 'Consumo de agua',
    ALLUTILITIES: 'Todos los servicios públicos',
    ALLEnergySources: 'Todas las fuentes de energía',
    WaterPerformance: 'Rendimiento del agua',
    WaterOverview: 'Visión general del agua',
    GASPERFORMANCE: 'Rendimiento del gas para',
    GASPERFORMANCEDETAILS: 'Rendimiento del gas',
    WATERPERFORMANCEDETAILS: 'Rendimiento del agua',
    SEWERAGEPERFORMANCE: 'Rendimiento aguas residuales',
    ALLSAVINGSBYUTILITY: 'Ahorro de BTU por servicio',
    TOTALENERGYCOST: 'Coste energético total',
    TOTALSAVINGS: 'Ahorro total',
    TOTALFOOTSPRINT: 'Huella total',
    INTEGRATIONTYPE: 'TIPO DE INTEGRACIÓN',
    UTILITYPROVIDER: 'PROVEEDOR DE SERVICIOS',
    ACCOUNTNUMBER: 'NÚMERO DE CUENTA',
    STATUS: 'ESTADO',
    ACTIONS: 'ACCIONES',
    SERVICESOVERVIEW: 'Servicios',
    AddService: 'AÑADIR SERVICIO',
    AllServices: 'Todos los servicios',
    Active: 'Activo',
    Inactive: 'Inactivo',
    Sewerage: 'Aguas residuales',
    ServiceProvider: 'Proveedor del Servicio',
    AccountNumber: 'Número de cuenta',
    CANCEL: 'CANCELAR',
    SELECTALL: 'Seleccionar todo',
    SEARCH: 'Buscar',
    SHOWACCOUNTNUMBERS: 'Mostrar todos los números de cuenta',
    BACK: 'VOLVER',
    SUBMIT: 'ENVIAR',
    Complete: 'COMPLETAR',
    DONE: 'HECHO',
    Utillity: 'Servicio',
    AllUtilityService: 'Todos los servicios',
    Weather: 'Tiempo',
    WeatherServices: 'Servicios meteorológicos',
    Weatherdata:
      'Los datos meteorológicos pueden integrarse con la vinculación de sus cuentas',
    CONFIGURE: 'CONFIGURA',
    METERID: 'ID METRO',
    SERVICETYPE: 'TIPO DE SERVICIO',
    METERINGPURPOSE: 'PROPÓSITO DE LA MEDICIÓN',
    SITESETTINGS: 'Configuración del sitio',
    SERVICESINTEGRATION: 'Servicios',
    USERMANAGEMENT: 'Gestión de usuarios',
    GENERALSETTINGS: 'Ajustes generales',
    UTILITYBILLTOOLTIPHEADER: 'Factura de servicios',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Rendimiento de los servicios',
    ELECTRICITYTOOLTIPHEADER: 'Ahorro de energía eléctrica',
    WATERTOOLTIPCONTENT:
      'Comparación del consumo de agua para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia.',
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      'Coste calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior. Nota - El coste se calcula sobre la base de los meses naturales y no es específico de los periodos de facturación de los servicios públicos.',
    UTILITYBILLTOOLTIPCONTENT:
      'Utilización y coste calculados para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior. Nota - El coste se calcula en función de los meses naturales y no de los periodos de facturación de la empresa.',
    CARBONTOOLTIPCONTENT:
      'Emisiones calculadas para el periodo seleccionado a partir de los datos reales con respecto a los datos del año anterior.',
    DATANEEDEDCONTENT:
      'Faltan datos de alcance 1, revise y actualice los datos cada mes.',
    CARBONTOOLTIPSECONDCONTENT:
      'Los cálculos de CO2 en tiempo real se basan en el contador principal, y los cálculos precisos de carbono se actualizan tras la generación de la factura de la empresa de servicios públicos.',
    CARBONTOOLTIPSUTILITY:
      'Emisión calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en la factura de servicios públicos proporcionada.',
    CARBONTOOLTIPLIVE:
      'Emisión calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior del contador in situ. Los cálculos de C02 en tiempo real se basan en el contador principal.',
    CARBONTOOLTIPINTRVAL:
      'Emisiones calculadas para la duración seleccionada a partir de los datos reales del año anterior. Los cálculos de emisión de carbono en tiempo real se basan en los datos del intervalo de la empresa de servicios públicos.',
    ELECTRICITYTOOLTIPCONTENT:
      'Ahorro de electricidad calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior.',
    DATANEEDED1:
      'Datos insuficientes: los datos de alcance 1 deben actualizarse cada mes.',
    GASTOOLTIPCONTENT:
      'Ahorro de gas calculado para la duración seleccionada a partir de los datos actuales con respecto a los datos del año de referencia.',
    ALLTOOLTIPCONTENT:
      'Ahorro calculado para el periodo seleccionado a partir de los datos actuales con respecto a los datos del año de referencia.',
    UTILITYVIEWDETAILSTOOLTIP:
      'Consumo y coste calculados para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior. Nota - El consumo y el coste se calculan en función de los meses naturales y no son específicos de los periodos de facturación de la empresa.',
    EMAASENERGYUSAGETOOLTIP:
      'Consumo calculado para el periodo seleccionado a partir de los datos actuales con respecto a los datos del año de referencia.',
    EMAASENERGYUSAGETOOLTIPPREV:
      'Consumo calculado para el periodo seleccionado a partir de los datos actuales con respecto a los datos del año anterior.',
    EMAASCONSUMPTIONTOOLTIP:
      'Uso calculado para la duración seleccionada a partir de los datos actuales comparados con los datos del año de referencia o del año anterior.',
    EMAASWATEROVERVIEWTOOLTIP:
      'Utilización calculada para la duración seleccionada a partir de los datos actuales con respecto a los datos del año anterior',
    EMAASNILMTOOLTIP:
      'Determine el desglose del consumo energético de su centro por tipos de equipos.',
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Ahorro total de costes de los servicios energéticos durante el periodo seleccionado.',
    PORTFOLIOSUMMARYEUITOOLTIP:
      'El EUI es un indicador de la eficiencia energética del diseño y/o funcionamiento de un edificio. El EUI se mide como la agregación de energía de la cartera dividida por el total de metros cuadrados de la cartera en un año.',
    SITESUMMARYEUITOOLTIP:
      'EUI es un indicador de la eficiencia energética del diseño y/o funcionamiento de un edificio. El EUI se mide como la agregación de energía del sitio durante los últimos 12 meses dividida por la superficie bruta total del sitio.',
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (Intensidad de uso de la energía)',
    SUMMARYEUITOOLTIPHEADERFORSITE:
      'EUI (Intensidad de uso de la energía) - {date}',
    PROVIDERLISTPLACEHOLDER: 'Buscar detalles del proveedor',
    PORTFOLIOSUMMARYHEADER: 'Resumen de carbono y energía',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Última actualización: {date}',
    AIModelDetails: 'Detalles del modelo AI',
    DATAUPLOAD: 'Carga de datos',
    ADDFUEL: 'Añadir combustible',
    ADD: 'Añadir',
    ADDCOMPOUND: 'Añadir Compuesto',
    ADDMETEREDGAS: 'Añadir Gas Medido',
    ADDSCOPETWO: 'Añadir Scope 2',
    EXCEEDEDLIMIT: 'excedido límite máximo hasta 4',
    DETAILS: 'Detalles',
    DATAUPLOADDETAILS:
      'Acceda a todas las funciones que requieren la introducción/carga manual de archivos de datos',
    DATAUPLOADCECARDSUBTITLE:
      'Realice un seguimiento del uso de las emisiones de carbono de alcance 1 para cumplir los objetivos de sostenibilidad de su empresa.',
    DATAUPLOADCARBONESUBTITLE:
      'Esta página presenta una tabla completa que muestra varios combustibles, sus cantidades correspondientes y los factores de emisión de carbono asociados para el año seleccionado.',
    SCOPEONETWOSUBTITLE:
      'Esta página presenta una tabla detallada que muestra las emisiones de Alcance 1 (Emisiones directas, incluida la combustión estacionaria y los refrigerantes) y Alcance 2 (Emisiones indirectas de la electricidad), junto con sus cantidades y los factores de emisión de carbono asociados para el año elegido.',
    METERDATASUBHEADER:
      'Acceda a todos sus archivos de datos cargados para obtener datos de los contadores.',
    DATAMISSINGALERTS: 'Alertas de falta de datos',
    UPLOAD: 'Carga masiva',
    UPLOADTOPADD: 'Subir archivo',
    PUBLISHFILE: 'Publicar',
    BASELINEFILE: 'Línea base',
    BASELINE_SUCCESS: 'Formación de la línea base iniciada con éxito',
    UPLOADTOP: 'Subir',
    UPLOADFILE: 'SUBIR',
    NAME: 'Nombre',
    DATATYPE: 'Tipo de datos',
    CREATEDON: 'Creado el',
    DATEOFUPLOAD: 'Fecha de carga',
    ALLUPLOADS: 'Todas las cargas',
    STATIONARYCOMBUSTION: 'Combustión estacionaria',
    REFRIGERANTS: 'Refrigerantes',
    WHEATHERDATA: 'Datos meteorológicos',
    UTILITYBILL: 'Factura de servicios públicos',
    SCOPE2: 'Alcance 2',
    METEREDGAS: 'Gas medido',
    NOFILESADDEDHEADER: 'Aún no hay archivos añadidos.',
    NOFILESADDEDMESSAGE:
      'Empiece cargando datos meteorológicos, de servicio o puntos de datos',
    UPLOADBUTTON: 'SUBIR',
    METER_DATA: 'Datos del contador',
    UTILITY_BILL: 'Factura de servicios públicos',
    FUEL_NAME: 'NOMBRE DEL COMBUSTIBLE',
    ENABLEIDSCHECKBOX: 'Habilitar IDS (Servicio de datos de intervalo)',
    ENABLED: 'Habilitado',
    DISABLED: 'Deshabilitado',
    UDSSTATUS: 'Estado mensual de DS',
    IDSSTATUS: 'Estado de intervalo de DS',
    DEACTIVATEUDSACCOUNT: 'Desactivar el Servicio de Datos Mensuales',
    DEACTIVATEIDSACCOUNT: 'Desactivar IDS (Servicio de Datos de Intervalo)',
    REACTIVATEIDSACCOUNT: 'Reactivar IDS (Servicio de datos de intervalo)',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      '¿Está seguro de que desea desactivar el IDS (Servicio de Datos de Intervalo) para el número de cuenta?',
    REACTIVATEIDSCONFIRMATIONNOTE:
      '¿Está seguro de que desea reactivar el IDS (Servicio de Datos de Intervalo) para el número de cuenta?',
    DEACTIVATEIDSACCOUNTMSSG:
      'Una vez desactivado el IDS, la aplicación no recuperará automáticamente los datos del intervalo de utilidad y solo se almacenarán los datos históricos.',
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Una vez reactivada la cuenta, la aplicación recuperará automáticamente los datos del intervalo de utilidad.',
    SwitchedOfffromCloud: 'Desconectado de la nube',
    SwitchedOfffromSite: 'Desconectado del sitio',
    SwitchedOfffromCloudToolTip:
      'El EO se desactiva manualmente desde la nube. Para activarlo, contacte con connectbuildingsupport@honeywell.com.',
    SwitchedOfffromSiiteToolTip:
      'El usuario desactiva manualmente la EO desde el sitio',
    EnableIDSText: 'El usuario desactiva manualmente la EO desde el sitio.',
    EnableIDSHeaderTxt: 'Habilitar IDS (Servicio de datos de intervalo)',
    EOSAVINGS: 'Ahorros TO',
    EOSUMMARY: 'Resumen EO',
    SELECT: 'Seleccionar',
    INPUT: 'Entrada',
    FAILEDTOACCESSMSGIDS:
      'No se pudo acceder a los datos del intervalo de utilidad',
    CONNECTIONERRORMESSAGEIDS: 'Algo salió mal.',
    VERIFICATIONINPROGIDS: 'Activación en curso',
    REACTIVATIONPROG: 'Reactivación en curso',
    VERIFICATIONINPROGMESSAGEIDS:
      'El proceso de verificación de la cuenta tarda de 2 a 3 días.',
    REACTIVATIONTOOLTIP:
      'La acción de reactivación en esta cuenta de ID se inicia nuevamente después de la desactivación',
    ENABLEIDSMSG: 'IDS (Interval Data Service) se ha habilitado correctamente.',
    EnergyStarNoScoreNote:
      'La puntuación Energy Star mostrada corresponde al {prevMonth}, ya que la puntuación del mes anterior no está disponible.',
    SEARCHFOR: 'Buscar',
    EnergyManagementSiteDashboardPortfolioTitle: 'Resumen de carbono y energía',
    CHOOSEDATATYPEMESSAGE:
      'Elija el tipo de datos a continuación para descargar la plantilla y continúe con el siguiente paso para cargar los archivos.',
    UPLOADMETERDATASTEPONEMESSAGE:
      'Paso 1: Descargar plantilla de datos de contadores',
    UPLOADMETERDATA: 'Cargar datos del contador',
    FILEUPLOADNOTE:
      'Nota: Sólo se aceptan archivos {type} y cada archivo no debe superar {size}mb.',
    UPDATEDFILEUPLOADNOTE:
      'Nota: Sólo se aceptan archivos CSV y el archivo no debe superar los 5 Mb.',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Instrucciones para cargar la plantilla.',
    INSTRUCTIONTEMPLATEONE:
      'Comience cargando los datos históricos de lectura de contadores utilizando la plantilla CSV proporcionada.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      'Asegúrese de que los valores de los datos cargados están en la unidad configurada en RBM para los contadores.',
    INSTRUCTIONTEMPLATEFIVE:
      'El usuario puede cargar un máximo de 10 archivos durante el proceso de carga, con un tamaño total combinado de archivos no superior a 1,5 GB.',
    INSTRUCTIONTEMPLATETWO:
      'El usuario puede cargar un máximo de 2 años de datos con intervalos de 1, 3, 5 ó 15 minutos y un tamaño de archivo de hasta 1,5 GB.',
    INSTRUCTIONTEMPLATETHREE:
      'Tenga en cuenta que el panel de control y los informes mostrarán los datos históricos de los contadores de los últimos 15 días y que todos los datos de los contadores cargados se utilizarán para entrenar un modelo de referencia de buena calidad.',
    INSTRUCTIONTEMPLATEFOUR: 'Ver ejemplo de plantilla CSV rellenada',
    UPLOAD_PROGRESS_IN_TOAST:
      'El progreso de la carga se puede ver en el Widget en la parte inferior de la pantalla.',
    PUBLISHMODALHEADER: '¿Listo para publicar?',
    ERRORINPUBLISHING:
      'Se ha producido un error al publicar los archivos. Vuelva a intentarlo dentro de un rato',
    WARNINGNOTIFICATIONFORPUBLISH: 'Se están cargando archivos adicionales',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      '¿Prefiere esperar antes de publicar o continuar publicando los archivos {filesToPublish}?',
    NOTEFORPUBLISHFILE:
      'Nota: Le notificaremos por correo electrónico una vez que se haya completado la publicación, y mostraremos los datos históricos del contador sólo de los últimos 15 días en el panel/informes.',
    INSTRUCTIONFORPUBLISHFILE: '¿Desea publicar los archivos cargados?',
    PUBLISHBUTTON: 'Sí, publicar',
    METERDATAPUBLISHINGMSG:
      'Por favor, espere mientras publicamos los datos, y le notificaremos por correo electrónico una vez que se haya completado.',
    METERDATAUPLOADFAILED:
      'Error en la carga del archivo: {fileName}. Vuelva a intentarlo dentro de un rato',
    METERDATAUPLOADSUCCESS: 'Archivo: {fileName} cargado correctamente',
    NOBUTTON: 'No',
    METERUPLOADINSTRUCTIONTITLE:
      'Instrucciones para cargar datos de contadores',
    METERUPLOADDOWNLOADCSV: 'Descargar plantilla CSV',
    METERUPLOADDOWNLOADEXCEL: 'Descargar plantilla CSV',
    METERUPLOADINSTRUCTIONONE:
      'Comience cargando los datos históricos de lectura de contadores utilizando la plantilla CSV proporcionada.',
    METERUPLOADINSTRUCTIONFOUR:
      'Asegúrese de que los datos descargados del supervisor no superan los 1,5 GB. Consulte las preferencias de tamaño de los datos que se proporcionan.',
    METERDATAEXCELDOWNLOAD: 'Descargar Excel de estimación',
    METERUPLOADINSTRUCTIONTWO:
      'Después de cargar los archivos CSV de todos los contadores de la instalación deseada, haga clic en el botón «Publicar» para procesar y rellenar los datos históricos.',
    METERUPLOADINSTRUCTIONTHREE:
      'Para establecer una línea de base, haga clic en "Acción de línea de base" y especifique el rango de datos deseado, y Forge AI entrenará la línea de base utilizando los datos históricos disponibles publicados.',
    CHOOSEDATATYPE: 'Elegir tipo de datos',
    NEXTUPLOAD: 'Siguiente-Subir',
    UPLOADDATA: 'Cargar datos',
    ADDNEWFUEL: 'Añadir nuevo combustible a',
    ADDNEWCOMPOUND: 'Añadir nuevo compuesto a',
    MANUALINPUT: 'ENTRADA MANUAL',
    UPLOADDATACAPS: 'CARGAR DATOS',
    ADDNEWFUELSUB:
      'Elija entre las siguientes opciones para introducir o cargar manualmente la plantilla',
    SCOPEONESC: 'Combustión estacionaria : Añadir combustible',
    SCOEONEREF: 'Refrigerantes : Añadir compuesto',
    SCOPETWO: 'Ámbito 2',
    UPLOADING: 'Cargar',
    FILES: 'archivos',
    FILE: 'archivo',
    UPLOADINGMESSAGE1:
      'El progreso de la carga y la información sobre el estado de estos archivos son visibles en la notificación tostada situada en la parte inferior central de la pantalla.',
    REDIRECTMESSAGE1: 'Será redirigido en',
    REDIRECTMESSAGE1OCR: 'Será redirigido pronto',
    REDIRECTMESSAGE2: 'seg.',
    UPLOADFILES: 'Cargar archivos para',
    UPLOADMETERDATASTEPTWOMESSAGE:
      'Paso 2: Cargar archivos para Datos de contador',
    UPLOADNOTE:
      'Sólo se aceptan archivos de {type} y cada archivo no debe exceder {size}mb',
    UPDATEDUPLOADNOTE:
      'Sólo se acepta un archivo CSV y el archivo no debe superar 1,5gb',
    UPDATEDUPLOADNOTESUB: '(sólo es posible cargar un archivo a la vez)',
    INSTRUCTIONBUTTON: 'ejemplo de plantilla CSV rellenada',
    FILEUPLOADPLACEHOLDER: 'Arrastre y suelte los archivos aquí',
    SINGLEFILEUPLOADPLACEHOLDER: 'Arrastre y suelte el archivo aquí',
    TOTALSIZEEXCEEDSERROR: 'El tamaño total supera el límite (1,5 GB)',
    NUMBEROFFILEALLOWED: 'Puede cargar hasta 10 archivos',
    FILEUPLOADPLACEHOLDERONLYONEFILE: '(sólo se puede cargar uno cada vez)',
    REMOVE: 'Eliminar',
    CHOOSESERVICE: 'Elegir servicio',
    CONNECT: 'Conectar',
    NEXT: 'Siguiente',
    CHOOSEUTILITYTYPE:
      'Seleccione el proveedor de servicios públicos, las credenciales y los detalles de la cuenta para integrar los datos.',
    CHOOSEUTILITYTYPEMANUAL:
      'Introduzca los datos del proveedor de servicios públicos y de la cuenta para cargar los datos manualmente.',
    EDITDETAILNOTE:
      'Introduzca a continuación los datos correctos de la cuenta y del contador. A continuación, haga clic en "Enviar" para actualizarlos y guardarlos.',
    EDITDETAILWHENBILLEXISTS:
      'Introduzca a continuación los datos correctos de la cuenta y del contador. A continuación, haga clic en "Enviar" para actualizarlos y guardarlos.',
    SEARCHPROVIDER: 'Buscar proveedor de servicios públicos',
    CONTACTSUPPORT:
      '¿No encuentra el proveedor de servicios? Póngase en contacto con el servicio de asistencia de Honeywell.',
    UTILITYPROVIDERLABEL: 'Proveedor de servicios',
    SERVICEPROVIDERNAME: 'PROVEEDOR DE SERVICIOS',
    INTEGRATIONTYPENAME: 'TIPO DE INTEGRACIÓN',
    UTILITYSERVICES: 'Servicios de Utilidad',
    UtilityHandoffNotification:
      "El tipo de integración de {manualCount} Cuenta de Servicios Públicos se puede convertir de 'Manual' a 'Automatizada'. Esto permitirá la actualización automática de las facturas de servicios públicos sin necesidad de realizar ninguna acción por su parte. Encuentre la opción en el menú 'Acciones' de la tabla inferior.",
    UTILITYSERVICESDETAILS:
      'Integre y gestione sus múltiples servicios para disponer de los datos automáticamente de forma rápida e inteligente.',
    ADDUTILITYSERVICE: 'Añadir servicio público',
    ADDUTILITYTYPE: 'Tipo de integración de servicios públicos',
    AUTOMATEDTEXT:
      'Proporcione sus credenciales para la cuenta del "Proveedor de servicios públicos" para permitir la recuperación mensual automática de los datos de sus facturas de servicios públicos.',
    MANUALTEXT:
      'Si no tiene credenciales para su proveedor de servicios y necesita actualizar manualmente la información de su factura de servicios todos los meses.',
    NOACCOUNTADDEDHEADER: 'Aún no hay cuentas de servicios públicos añadidas.',
    NOACCOUNTADDEDMESSAGE:
      'Empiece integrando cuentas para gestionar facturas y tarifas',
    ADDACCOUNTNUMBER: 'Añada',
    SELECTUTILITY: 'Seleccione una Utilidad',
    ACCNUMBER: 'Número de cuenta*',
    UTILITYPROVIDERERROR:
      'Proveedor de servicios públicos no encontrado. Póngase en contacto con su gestor de Honeywell para que le ayude a convertir esta cuenta',
    PASSWORD: 'Contraseña',
    USERNAME: 'Nombre de usuario*',
    SIGNIN: 'Iniciar sesión',
    UPLOADBTN: 'SUBIR',
    UTILITYPROVIDERTOOLTIPTXT:
      'Introduzca el nombre del proveedor de servicios públicos que figura en la factura.',
    VERIFICATIONINPROCESS: 'Verificación en curso',
    VERIFICATIONMSSG1:
      'El proceso de verificación de la cuenta tarda 2/3 días.',
    UPDATECREDENTIALS: 'Actualizar credenciales',
    UPDATECREDENTIALSNOTE:
      'Introduzca su contraseña actualizada de «Nombre del proveedor de servicios» para activar su cuenta.',
    ENTERCREDENTIALS: 'Introducir credenciales',
    ENTERCREDENTIALSNOTE:
      'Utilice sus credenciales de "Nombre del proveedor de servicios" para vincular la cuenta.',
    PLEASEUSESERVICE:
      'Utilice sus credenciales de "Proveedor de servicios" para vincular la cuenta.',
    FILEEMPTYERRORMSG: 'Error. El archivo está vacío, vuelva a cargarlo.',
    FILESIZEERRORMSG:
      'El tamaño del archivo supera los 50 mb. Reduzca el tamaño del archivo e inténtelo de nuevo.',
    FILEMAXSIZEERRORMSG:
      'El tamaño del archivo excede {maxSize}. Por favor, reduzca el tamaño del archivo e inténtelo de nuevo.',
    FILEHEADERERROR:
      'El archivo tiene cabeceras no válidas. Utilice la plantilla proporcionada y vuelva a cargarlo.',
    CSVFILEINVALID:
      'Los datos/nombre del archivo CSV cargado no son válidos. Compruebe el archivo e inténtelo de nuevo.',
    CSVFILEINVALIDNAME:
      'El archivo CSV cargado no es válido. No se admiten caracteres especiales ni extensiones múltiples.',
    DEACTIVATEACCOUNT: 'Desactivar cuenta',
    REACTIVATEACCOUNT: 'Reactivar cuenta',
    CONVERTTOAUTOMATIC: 'Convertir a "Automático"',
    MANAGEBILLDETAILS: 'Gestionar detalles de la factura',
    MANAGETARIFFDETAILS: 'Gestionar tarifas',
    EDITACCOUNTDETAILS: 'Editar detalles de la cuenta',
    EDITACCOUNTDETAILSTOOLTIP:
      'El usuario puede editar todos los campos en caso de que no haya facturas cargadas.',
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      'El usuario puede editar el número de cuenta',
    CONVERTINTRGRATIONTYPE: 'Convertir a "Automático"',
    DELETE: 'Borrar',
    DELETING: 'Borrar',
    DEACTIVATECONFIRMATIONNOTE:
      '¿Está seguro de que desea desactivar el número de cuenta?',
    REACTIVATECONFIRMATIONNOTE:
      '¿Está seguro de que desea reactivar el número de cuenta?',
    DEACTIVATEUTILITYACCOUNTMSSG:
      'Una vez desactivada la cuenta, la aplicación no buscará automáticamente la información de la factura de servicios públicos y sólo se almacenará la información histórica.',
    REACTIVATEUTILITYACCOUNTMSSG:
      'Una vez reactivada la cuenta, la aplicación buscará automáticamente la información de la factura de servicios públicos.',
    YES: 'Sí',
    NO: 'No',
    REVERIFYNOTE:
      'Introduzca sus credenciales de "Proveedor de servicios" para vincular la cuenta.',
    REVERIFYHEADER: 'Verificar credenciales y número de cuenta',
    REVERIFY: 'Verificar de nuevo',
    UPDATE: 'Actualizar',
    REENROLL: 'Reactivar cuenta',
    save: 'GUARDAR',
    ACCOUNTMISSINGHEADER: 'Actualizar número de cuenta',
    ACCOUNTMISSINGNOTE:
      'Introduzca sus credenciales de "Proveedor de servicios" y el número de cuenta para vincular la cuenta.',
    SHOWMORE: 'Ver más',
    NORESULTS: 'No se han encontrado resultados.',
    BREAKDOWNBYSITE: 'Desglose por centro ({count})',
    PORTFOLIOENERGY: 'Energía',
    PORTFOLIOENERGYCONS: 'Energía Cons.',
    PORTFOLIOCONSUMTION: 'Consumo',
    PORTFOLIOWATER: 'Agua',
    PORTFOLIOWATERCONS: 'Consumo de agua',
    ENERGYUSAGEBYSITE: 'Consumo de energía por centros ({count})',
    ENERGYBYSITE: '* En la tabla solo se muestran los sitios con datos',
    REFRESH: 'Refrescar',
    DAYS: 'días',
    PARTIAL_MONTH: 'Mes parcial',
    ADD_UTILITY_SERVICE: 'Añadir servicio de utilidad',
    ADD_ACCOUNT: 'AÑADIR CUENTA',
    ACCOUNT_NUMBER: 'Número de cuenta',
    BILLING_CYCLE: 'Ciclo de facturación',
    PERIOD: 'Período',
    SITEWITHDATA: '* En la tabla solo se muestran los sitios con datos',
    ELECTRICITYUSAGEBYSITE: 'Consumo de electricidad por centros ({count})',
    GASUSAGEBYSITE: 'Consumo de gas por centros ({count})',
    WATERUSAGEBYSITE: 'Consumo de agua por centros ({count})',
    ENERGYOPTIMIZATION: 'Optimización Energética',
    ENERGYOPTIMIZATIONNEW: 'Optimización Energética',
    ENERGYOPTIMIZATIONEO: 'Optimización Energética (EO)',
    ENERGYOPTIMIZATIONSAVINGS: 'Ahorro EO',
    EOSETTINGSUBTITLE:
      'EO supervisa, mide y optimiza continuamente la climatización de los edificios para conseguir el menor consumo energético en todas las situaciones, minimizando la energía gastada en calefacción y refrigeración de una instalación y de forma continua.',
    EOSETTINGMODALHEADER: '¿Optimización Energética Inactiva?',
    EOSETINGMODALCONTENT:
      'La Optimización Energética no monitoriza, mide y optimiza continuamente la climatización de sus instalaciones para conseguir el menor consumo energético.',
    EOSETINGMODALCONTENTSUB:
      '¿Está seguro de que desea Inactivar la Optimización de Energía?',
    EOENABLETITLE: 'Habilitar la optimización de energía para este sitio.',
    EOSTATUSMESSAGESUCCESS:
      'Optimización Energética activada para este sitio con éxito.',
    EOSTATUSMESSAGEERROR:
      'Optimización Energética desactivada para este sitio con éxito.',
    EOSETTINGNODATAAVAILABLE:
      'Póngase en contacto con el administrador del sistema, la configuración no está completa.',
    EOSavings: 'Optimización Energética Ahorros',
    EOUtility_all: 'Todos los servicios',
    EOUtility_electricity: 'Electricidad',
    EOUtility_gas: 'Gas',
    EOUtility_steam: 'Vapor',
    EOUtility_chilledwater: 'Agua refrigerada',
    EOUtility_hotwater: 'Agua caliente',
    inactiveDays: 'Días inactivos',
    inactiveDay: 'Día inactivo',
    excludedDays: 'Días excluidos',
    excludedDay: 'Día excluido',
    activeHours: 'Horas activas',
    activeDay: 'Active Day',
    savingsSummaryEO:
      'Ahorro estimado (Con {opertionalPercentage}% de tiempo de funcionamiento del OE)',
    operationalTimeEO:
      '{opertionalPercentage}% de tiempo de funcionamiento del OE',
    timeUsedForBaselining: '{baseline}% time used for baselining',
    siteComfort: 'Confort del sitio',
    activeStrategyStatus: 'Activo',
    inactiveStrategyStatus: 'Inactivo',
    lastUpdated: 'Última actualización:',
    CALCULATED: 'Línea de base',
    ESTIMATEDSAVINGS: 'Ahorro estimado',
    OPPORTUNITYFROMEO: 'Opportunity from EO',
    EMAASEOSTATETOOLTIP:
      'El estado activo o inactivo indica la estrategia de optimización en uso.',
    EOSAVINGTOOLTIP:
      'Ahorro de energía cuando se ejecutó la Optimización Energética en comparación con el uso de energía calculado.',
    EOSAVINGONENABLE: 'Ahorro en los días habilitados para EO',
    EOSAVINGENTIREPERIOD: 'Ahorro durante todo el periodo',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'Ningún ahorro en el intervalo de tiempo seleccionado. Para conocer el ahorro estimado, considere ampliar la duración seleccionada a un periodo más largo.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      'Uso calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia. El EUI se calcula a partir de los datos energéticos de las facturas de los servicios públicos.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      'Uso calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior. El EUI se calcula a partir de los datos energéticos de las facturas de los servicios públicos.',
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      'Uso calculado para la duración seleccionada a partir de los datos reales con respecto a los datos de referencia o del año anterior. El EUI se calcula a partir de los datos energéticos de las facturas de los servicios públicos.',
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      'El consumo se calcula para el periodo seleccionado a partir de los datos reales, comparados con los datos anteriores o de referencia de la compañía eléctrica y del contador activo, respectivamente. El uso mensual se basa en la energía diaria media de las facturas de la empresa de suministro, normalizada para meses completos cuando abarca dos meses.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'El uso se calcula para el periodo seleccionado a partir de los datos reales, comparados con los datos de referencia del contador in situ.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      'El consumo se calcula para el periodo seleccionado a partir del consumo real, comparado con los datos de referencia de los intervalos de la compañía eléctrica.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'El consumo se calcula para el periodo seleccionado a partir del consumo real, comparado con los datos anteriores del contador in situ.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      'El consumo se calcula para el periodo seleccionado a partir del consumo real, comparado con los datos del periodo anterior procedentes de las facturas de la compañía eléctrica. El uso mensual se basa en la energía diaria media de las facturas de servicios públicos, normalizada para el mes completo cuando la factura abarca dos meses.',
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Cambio',
    PORTFOLIOSITECOUNT: 'Desglose por centro ({count})',
    UTILITYCOSTBYSITES: '{Utility} Coste por centros ({count})',
    ALLUTILITYCOSTBYSITES:
      'Coste de los servicios públicos por centros ({count})',
    SOLAR: 'Solar',
    WIND: 'Eólica',
    SOLARPERFORMANCE: 'Rendimiento solar',
    WINDPERFORMANCE: 'Rendimiento eólico',
    UTILITYCOSTOVERVIEW: 'Resumen de costes de servicios públicos',
    DESCRIPTIONNOTIFICATION:
      'Ha alcanzado el número máximo de cuentas de servicios públicos para el mismo tipo de servicio público. Póngase en contacto con su administrador para crear más cuentas.',
    TITLENOTIFICATION: 'Límite de cuentas alcanzado.',
    ENERGYUSAGECAPS: 'CONSUMO DE ENERGÍA',
    UPDATEERRORMESSAGE: 'Algo ha ido mal. Vuelva a intentarlo más tarde.',
    MANUALTOAUTOMATICCONVERSION:
      'La conversión de cuenta de Manual a Automática se ha iniciado correctamente.',
    MANUAL: 'Manual',
    AUTOMATED: 'Automático',
    MONTHLY: 'Mensual',
    BILLING: 'Facturación',
    APPLY: 'APLICAR',
    RESET: 'REINICIAR',
    CLOSE: 'CERRAR',
    SCOPE1FUELTYPES: 'Alcance 1 Tipos de combustible',
    SCOPE1FILTERSUBHEADER: 'El filtro cambia sólo la vista gráfica',
    SCOPE1DATAMISSING: 'Faltan datos de alcance 1',
    SCOPE1SHOWMISSINGDATA:
      'Por favor, revise los datos que faltan del alcance 1 y actualícelos',
    FUELGASTYPE: 'Tipo de combustible / gas',
    COMPOUNDTYPE: 'Tipo de compuesto',
    UTILITYTYPE: 'Tipo de servicio',
    FUELGASTYPESELECT: 'Seleccione un tipo de combustible / gas',
    COMPOUNDSELECT: 'Seleccione un tipo de compuesto',
    UTILITYSELECT: 'Seleccione un tipo de servicio público',
    EMISSIONFACTOR: 'Factor de emisión de CO2',
    SelectCategory: 'Seleccione Categoría',
    UNIT: 'Unidad',
    UNITSELECT: 'Seleccione una unidad',
    StationaryCombustion: 'Combustión estacionaria',
    YEAR: 'Año',
    Country: 'País',
    State: 'Estado',
    YEARSELECT: 'Seleccione un año',
    MONTH: 'Mes',
    Override: 'Anular',
    MONTHSELECT: 'Seleccionar un mes',
    ADDDATA: 'Añadir datos',
    NOFUELCONSUMED: 'Sin combustible consumido',
    NOCONSUMED: 'No Consumo',
    QUANTITY: 'Cantidad',
    QUANTITYENTER: 'Introducir Cantidad',
    COSTSCOPE: 'Coste',
    COSTENTER: 'Introducir Coste',
    EDIT: 'Editar',
    YEARCHECK: 'año',
    MONTHERROR: 'Seleccionar otro mes',
    SUCCESS: 'Datos actualizados correctamente',
    CO2FACTORROOLTIPHEADER: 'Factor de emisión de CO2',
    PLEASENOTE: 'Tenga en cuenta:',
    PLEASENOTETEXT:
      'El nuevo factor de emisiones de carbono se utilizará en el próximo cálculo de emisiones de carbono. Los valores de emisiones de carbono ya calculados no se recalcularán utilizando el nuevo valor.',
    CO2FACTORROOLTIPCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada',
    CO2FACTORSCCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Introduzca el valor equivalente en kgCo2e/mmbtu para la unidad seleccionada.',
    CO2FACTORRFCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Introduzca el valor equivalente en MTCo2e/mmbtu para la unidad seleccionada.',
    CO2FACTORSCOPETWOANDGASCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Introduzca el valor equivalente para la unidad seleccionada.',
    FUELTABLETEXT:
      'Los siguientes tipos de combustible pertenecen a las emisiones de Alcance 1',
    FUELNAME: 'NOMBRE DEL COMBUSTIBLE',
    UTILITYTYPES: 'TIPOS DE SERVICIOS PÚBLICOS',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE:
      'Descargar plantilla CSV de datos del contador',
    EDIT_ACCOUNT_DETAILS: 'Editar detalles de la cuenta',
    ADD_METERS: 'Añadir contadores',
    UTILITY_TYPES: 'TIPOS DE SERVICIOS PÚBLICOS',
    CONVERT_INTEGRATION_TYPE: 'Convertir a "Automático"',
    METEREDGASHEADER:
      'Abajo Los tipos de servicios públicos pertenecen a las emisiones de Alcance 1',
    SCOPETWOHEADER:
      'Los siguientes tipos de servicios públicos pertenecen a las emisiones de alcance 2',
    UNITDROPDOWNNAME: 'Unidad',
    COMPOUNDTABLETEXT:
      'Abajo Los tipos de compuestos pertenecen a las emisiones de alcance 1',
    ENERGYCONSUMPTIONNILM: 'Consumo de energía',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'El gráfico muestra el consumo de energía y su desglose durante el periodo seleccionado',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE: 'Consumo de energía por tipo de equipo',
    METERNAME: 'Nombre del contador',
    METERNUMBER: 'Número de contador',
    CONSUMPTIONUNIT: 'Unidad de consumo',
    DEMANDUNIT: 'Unidad de demanda',
    CURRENCYUNIT: 'Unidad de moneda',
    TOTALMETERS: 'TOTAL DE CONTADORES',
    METERNAMECHANGEDESCRIPTION:
      'A continuación se muestra la lista de ID de contadores asociados a la cuenta',
    METERNAMEUPDATESUCCESS:
      'ID de contador: ({meterId}) se ha nombrado correctamente a «({meterName})»',
    METERNAMECHARACTERS: 'Utilice sólo caracteres alfanuméricos',
    METERNAMEMAXLENGTH: 'Longitud máxima: {maxCh} Caracteres',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Panorama del consumo ({rate})',
    DEMAND_OVERVIEW: 'Panorama de la demanda ({rate})',
    DEMAND: 'Demanda',
    CONSUMPTION_RATE_OVERVIEW: '{name} Resumen ({rate})',
    ELECTRICITYBLENDEDRATE: 'Tarifa eléctrica combinada ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Resumen de costes ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: 'Coste de la electricidad ({rate})',
    COST: 'Resumen de consumo',
    SUMMARY: 'Resumen',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Gestionar columnas',
    RESET_ALL_FILTERS: 'Restablecer todos los filtros',
    DOWNLOAD_CSV: 'Descargar CSV',
    DOWNLOAD_PDF: 'Ver y descargar PDF',
    UTILITY_BILL_ANALYSIS: '{utilityName} Análisis de facturas',
    NOTIFICATIONBOXFORMONTHLY:
      'El análisis de la factura de electricidad viene con las vistas Mensual y Periodo de facturación. La vista mensual calcula la factura de electricidad desde el principio hasta el final del mes en base a los datos promediados. Ejemplo ( 01 Mayo, 2022- 31 Mayo, 2022). Mientras que la vista Periodo de facturación calcula la factura de servicios según el ciclo de facturación real. Ejemplo (22 Mayo, 2022- 22 Junio, 2022). Haga clic en el periodo de facturación para ver los datos según el ciclo de facturación real.',
    SUMMARYTABLEAPIONGOING:
      'Las llamadas a la tabla resumen se procesan por lotes, haga clic después de cargar todos los datos de la tabla.',
    NOTIFICATIONFORBILLINGPERIOD:
      'La vista del periodo de facturación calcula la factura de servicios según el ciclo de facturación real. Ejemplo (22 de mayo de 2022- 22 de junio de 2022).',
    VIEW_OVERVIEW: 'Vista general',
    FILE_DELETED_SUCCESSFULLY: 'Archivo eliminado correctamente',
    FILE_DELETEING_ERROR:
      'Error al eliminar el archivo. Vuelva a intentarlo dentro de un rato.',
    AVG_CONSUMP_PER_MTH: 'Consumo medio mensual',
    AVG_CONSUMP_PER_DAY: 'Consumo medio por día',
    MTHLY_CONSUMP_PER_SQFT: 'Consumo mensual por m2',
    CURRENTEOSTATUS: 'Estado actual de la OE:',
    ON: 'Encendido',
    OFFMANUALSWITCHEDOFF: 'Apagado-Manual Apagado',
    OFFLINE: 'Desconectado',
    EONotOptimizing: 'EO Not Optimizing',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Planificado para mejorar la línea de base',
    EOON: 'El estado EO On indica la estrategia de optimización actual en uso',
    EOMANUALSWITHCHEDOFF:
      'el punto de consigna no se ha aplicado desde que el EO se desconectó manualmente',
    PLANNEDOFFFORBASELINE:
      'EO está planificado desactivado para la mejora de la línea de base',
    STATUSNOTAVAILABLE: 'Status not available',
    STATUSNOTAVAILABLETOOLTIP:
      'Status details are not present at this time. Please contact the Honeywell support team - connectedbuildingsupport@honeywell.com to resolve this condition',
    EOOFFLINE:
      'El estado EO desactivado indica que la estrategia de optimización no está en uso debido a un fallo de optimización.',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Tipo de alarma',
    CONFIGUREALARMDESCLINE1:
      'Seleccione el tipo de alarma para los contadores a configurar',
    CONFIGUREALARMDESCLINE2:
      'Seleccione el tipo de alarma para que los contadores emitan alarmas si el consumo de energía supera el valor de referencia en el intervalo mencionado.',
    ALLMETERS: 'Todos los contadores',
    SEARCHALARMTYPE: 'Seleccione el tipo de alarma',
    SEARCHMETERS: 'Buscar contador',
    THRESHOLDSETTINGS: 'AJUSTES DE UMBRAL',
    NOMETERSSELECTED:
      '"Seleccione como mínimo uno o varios medidores en el panel para cambiar los valores de umbral".',
    THRESHOLDALARM: 'ALARMA DE UMBRAL',
    ALARMNAME: 'Nombre de la Alarma',
    MINTHRESHOLD: 'Umbral Mín',
    MAXTHRESHOLD: 'Umbral Máx',
    TO: 'a',
    RESETTODEFAULTS: 'Restablecer por defecto',
    SAVE: 'GUARDAR',
    NOMETERSUNDERSITE: 'No hay contadores disponibles',
    NOSITESAVAILABLE: 'No hay sitios disponibles',
    VALIDATIONREQUIRED:
      'Debe seleccionarse al menos una prioridad y rellenarse todas las entradas bajo la misma',
    VALIDATIONOVERLAPPING:
      'Los datos introducidos no son válidos o se solapan con otros valores'
  },
  urjanetStatus: {
    ENROLLED: 'Inscrito correctamente',
    ENROLLEDMSG: 'La extracción de la cuenta se ha realizado correctamente',
    SUCCESSFUL_DELIVERED: 'Entregada con éxito',
    SUCCESSFUL_DELIVEREDMSG:
      'La extracción y la entrega de la cuenta se han realizado correctamente',
    PRODUCTION: 'Producción',
    PRODUCTIONMSG: 'La cuenta está en producción',
    Active: 'Activo',
    ACTIVEMSG:
      'La cuenta manual existe y el usuario puede introducir facturas manuales.',
    Enroll_Successful: 'Inscripción_exitosa',
    FAILEDLOGIN: 'Login fallido',
    NEEDSCREDENTIAL: 'Necesita credencial',
    NEEDSCREDENTIALMSG: 'La cuenta no tiene una credencial asociada',
    FAILEDTOACCESS: 'Acceso fallido.',
    NEEDSTEMPLATE: 'Necesita plantilla',
    NEEDSTEMPLATEMSG:
      'La cuenta tiene una credencial pero esa credencial no tiene una plantilla asignada',
    UNDERREVIEW: 'En revisión',
    UNDERREVIEWMSG: 'Fallo con estado genérico',
    WEBSITEISSUE: 'Problema con el sitio web',
    WEBSITEISSUEMSG: 'La cuenta no puede conectarse al sitio web.',
    CAPTCHALOGIN: 'Inicio de sesión con Captcha',
    CAPTCHALOGINMSG:
      'El inicio de sesión está bloqueado por Captcha en el sitio web',
    TEMPLATEFAILURE: 'Fallo de plantilla',
    TEMPLATEFAILUREMSG:
      'Un problema con la plantilla ha impedido la extracción',
    NEEDSENROLLMENT: 'Necesita inscripción',
    NEEDSENROLLMENTMSG: 'La cuenta necesita ser registrada',
    NOBILL: 'Sin factura',
    NOBILLMSG: 'La cuenta no tiene factura disponible en el sitio web',
    REENROLLED: 'Reinscrita',
    REENROLLEDMSG: 'La cuenta se registra de nuevo después de la desactivación',
    NAVIGATIONFAILURE: 'Fallo de navegación',
    NAVIGATIONFAILUREMSG:
      'Es necesario corregir la plantilla para estas cuentas',
    SOURCEFORMATCHANGE: 'Cambio_Formato_Fuente',
    SOURCEFORMATCHANGEMSG: 'Se ha detectado un nuevo formato de factura',
    ACCOUNTNUMBERCHANGE: 'Cambio_Número_Cuenta',
    ACCOUNTNUMBERCHANGEMSG: 'El número de cuenta ha cambiado al nuevo',
    USERACTIONREQUIRED: 'Usuario_Acción Requerida',
    USERACTIONREQUIREDMSG: 'Acción requerida del cliente',
    MIGRATION: 'Migración',
    MIGRATIONMSG: 'Cuenta migrada con nuevo proveedor/número de cuenta',
    INITIALTEMPLATEDEVELOPMENT: 'Inicial_Desarrollo Plantilla',
    INITIALTEMPLATEDEVELOPMENTMSG: 'La plantilla está en desarrollo',
    REJECTED: 'Rechazado',
    REJECTEDMSG: 'Cuentas rechazadas ya que no son válidas para procesar',
    EBILLENROLLMENT: 'Inscripción en factura electrónica',
    EBILLENROLLMENTMSG:
      'Cuenta para la que la inscripción a la factura electrónica está requierida/pendiente',
    CREDENTIALUPDATED: 'Credenciales actualizadas',
    CREDENTIALUPDATEDMSG:
      'Las credenciales han sido actualizadas después de fallar, el proceso de verificación de la cuenta tarda 2/3 días.',
    TEMPLATEUPDATED: 'Plantilla actualizada',
    TEMPLATEUPDATEDMSG: 'La plantilla se ha actualizado pero no se ha probado',
    UNKNOWN: 'Desconocido',
    UNKNOWNMSG: 'El estado de la cuenta es desconocido',
    PENDINGMSG: 'El estado de la cuenta es pendiente',
    PENDING: 'Pendiente',
    DELETED: 'Borrada',
    DELETEDMSG: 'La cuenta ha sido eliminada',
    ENROLLMENTFAILUREMSG: 'Fallo en la inscripción de la cuenta',
    ENROLLMENTFAILURE: 'Fallo de inscripción',
    DOESNOTEXIST: 'No_existe',
    DOESNOTEXISTMSG: 'La cuenta no existe',
    ACCOUNTNUMBERMISMATCHMSG: 'El número de cuenta no coincide',
    ACCOUNTNUMBERMISMATCH: 'Número de cuenta incorrecto',
    CONVERSIONINPROGRESS: 'Conversión en curso',
    CONVERSIONINPROGRESSMSG:
      'Conversión de cuenta en curso de manual a automática',
    FAILEDTOACCESSMSG:
      'La extracción no devolvió nada (podría ser un sitio web nuevo o una navegación rota)',
    FAILEDLOGINMESSAGE:
      'La navegación falló en el paso de inicio de sesión específicamente (comprobar usuario/contraseña)',
    ACCOUNTMISSING: 'Falta la cuenta',
    ACCOUNTMISSINGMESSAGE:
      'La credencial se ejecutó y tuvo éxito en alguna capacidad, pero no había rastro de esta cuenta',
    CONNECTIONERROR: 'Error de conectividad',
    CONNECTIONERRORMESSAGE:
      'Algo ha ido mal, por favor vuelva a introducir las credenciales de "Proveedor de Servicios" para la cuenta.',
    BLOCKED: 'Cuenta bloqueada',
    BLOCKEDMESSAGE: 'Login Bloqueado.',
    INACTIVE: 'Cuenta inactiva',
    INACTIVEMESSAGE: 'La cuenta está inactiva.',
    FINALLED: 'Cuenta cerrada',
    FINALLEDMESSAGE:
      'Revisar cuenta y dar de baja la cuenta si ya no necesita ser procesada.',
    VERIFICATIONINPROG: 'Verificación en curso',
    REENROLLMENTPROG: 'Reinscripción en curso',
    SUBMITTED: 'Enviado',
    SUBMITTEDMSG:
      'Estado inicial de la cuenta; debería proceder automáticamente',
    NOMINATEDPROG: 'Nominado',
    METERSMISMATCHED: 'DesajusteContadores',
    METERSMISMATCHEDMSG:
      'Los datos del contador no coinciden, actualícelos en Editar datos de cuenta.',
    VERIFICATIONINPROGMESSAGE:
      'El proceso de verificación de la cuenta tarda 2/3 días.',
    REENROLLMENTTOOLTIP:
      'La acción de reinscripción en esta cuenta se inicia de nuevo tras la desactivación.',
    NOMINATEDMESSAGE:
      'La cuenta tiene una credencial totalmente aprovisionada que aún no se ha ejecutado',
    DATAUNAVAILABLE: 'Estado de cuenta fallido',
    STATEMENTMISSING: 'Extracto perdido',
    DATAUNAVAILABLEMESSAGE:
      'Se ha extraído un extracto, pero no se ha conservado debido a fallos de auditoría, fallos de almacenamiento, etc.',
    STATEMENTMISSINGMSG:
      'La credencial se ha ejecutado correctamente y la cuenta se ha visto en el sitio web, pero no se ha podido extraer ningún extracto.',
    NOTENROLLED: 'No registrada',
    NOTENROLLEDMESSAGE:
      'La extracción de la cuenta se ha realizado correctamente, pero la cuenta en cuestión no está suscrita.',
    DEACTIVATED: 'Desactivado',
    DEACTIVATEDMESSAGE: 'La cuenta ya no está activa.',
    REVIEWACCOUNTANDUNS:
      'Revise la cuenta y cancele la suscripción si ya no es necesario procesarla',
    ERROR: 'Error',
    ERRORMESSAGE: 'Algo ha ido mal. Por favor, contacte con su administrador.',
    LOGINFAILURE: 'Fallo de conexión',
    LOGINFAILUREMESSAGE:
      'El inicio de sesión ha fallado debido a que la contraseña de la cuenta del proveedor de servicios ha cambiado o ha caducado.',
    DEACTIVATIONINITIATEDMSSG: 'Desactivación iniciada.',
    DEACTIVATIONINITIATED: 'Desactivación en curso',
    REENROLLEDREQUIRED: 'Reinscripción requerida',
    REENROLLEDREQUIREDMSG:
      'Es necesario volver a registrar la cuenta. Por favor, introduzca las credenciales de nuevo haciendo clic en actualizar.',
    INTERVALSNOTSUPPORTED: 'No soportado',
    INTERVALSNOTSUPPORTEDMSG:
      'IDS is not supported by the utility provider for this account.'
  },
  virtualMeters: {
    SELECTED: 'Contadores de Electricidad - Seleccionados ({count})',
    SEARCHMETERS: 'Buscar Nombre del contador',
    METERGROUPDETAILS: 'DETALLES DEL GRUPO DE CONTADORES',
    METERGROUPNAME: 'Nombre del grupo de contadores',
    DESCRIPTION: 'Descripción',
    DESCRIPTIONPLACEHOLDER: 'Máximo 240 caracteres',
    VALIDATIONREQUIRED:
      'Se deben seleccionar al menos dos contadores y rellenar ambas entradas',
    SAVE: 'GUARDAR',
    CANCEL: 'CANCELAR'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Emisiones totales',
    TOTALEMISSION: 'Emision total',
    SCOPEONETITLE: 'Emisiones de carbono por Alcance 1',
    SCOPETWOTITLE: 'Emisiones de carbono por Alcance 2',
    SCOPE1: 'Alcance 1',
    SCOPE2: 'Alcance 2',
    SCOPEONEDATANOTCONSIDER: 'Los datos de Alcance 1 necesitan actualizaciones',
    CARBONTITLE: 'Emisiones de carbono',
    PORTFOLIOCARBONTITLE: 'Emisiones de carbono de la cartera (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      'Emisión calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior.',
    SCOPEONETOOLTIP:
      'Emisión directa calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior.',
    SCOPETWOTOOLTIP:
      'Emisión indirecta calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior.',
    CARBONDETAILKEY: 'detallecarbono',
    SCOPEONEKEY: 'detalleResumenSinDivisa',
    UTILITYDETAILKEY: 'detalleservicio',
    METER: 'METRO',
    METERNAME: 'NOMBRE DEL CONTADOR',
    FUELTYPE: 'TIPO DE COMBUSTIBLE',
    SITES: 'LUGARES',
    SOURCE: 'FUENTE',
    CURRENTAVOIDANCE: 'EVASIÓN ACTUAL',
    PREVIOUSAVOIDANCE: 'EVASIÓN ANTERIOR',
    UTILITYTYPE: 'TIPO DE UTILIDAD',
    ACTUALEMISSION: 'EMISIONES REALES',
    ACTUALEMIS: 'EMISIONES REALES',
    PREVIOUSEMISSION: 'EMISIONES ANTERIORES',
    PREVIOUSPERIOD: 'EMIS. ANTERIORES',
    PREVIOUSEMISSIONS: 'Emisiones anteriores',
    PORTFOLIOPREVIOUSConsumption: 'PERIODO ANTERIOR',
    PORTFOLIOACTUALEMISSION: 'EMISIONES REALES',
    PORTFOLIOPREVIOUSEMISSION: 'EMISIONES EMISIONES',
    PORTFOLIOPREVIOUSCOST: 'PREV. COSTE',
    CHANGE: 'CAMBIO',
    ACTUALCONS: 'CONS. REALES',
    BASELINECONSP: 'CONS.',
    PREVPERIOD: 'PREV. PERIODO',
    CHANGEPERCENT: 'CAMBIO',
    EUICURRENT: 'EUI ACTUAL',
    EUIPRVPERIOD: 'EUI PERIODO PRV. PERIODO',
    PORTFOLIOACTUALCOST: 'COSTE REAL',
    SAVINGS: 'AHORRO',
    FuelType: 'Tipo de combustible',
    Emissions: 'EMISIONES',
    CARBONAVOIDANCE: 'Evitar emisiones de carbono',
    carbonEmissionsAvoidance: 'Emisiones de carbono evitadas',
    TOTALAVOIDANCETOOLTIP:
      'Evitación de emisiones de carbono calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior.',
    Meters: 'Contadores',
    ActivePower: 'Potencia activa',
    ActivePowerContent:
      'Potencia instantánea medida para un instante de tiempo determinado.',
    AVGpower: 'Potencia media',
    PeakPower: 'Potencia pico',
    PeakPowerContent:
      'Potencia máxima demandada para el intervalo de fechas seleccionado.',
    LoadType: 'Tipo de carga',
    LoadTypeContent: 'Tipo de carga a la que está asociado el contador.',
    FifteenMinuteElectricConsumption: '15 Min. Cons.',
    FifteenMinuteElectricConsumptionPrediction: '15 Min. Pred.',
    ElectricityConsumption: 'Consumo total de energía',
    EnergyConsSelectedPeriod: 'Consumo Energético Periodo Seleccionado',
    EnergyConsToday: 'Consumo Energético Hoy',
    EnergyConsTodayContent: 'Consumo total de energía para hoy.',
    EnergyConsMonth: 'Consumo Energético Mes',
    EnergyConsMonthContent: 'Consumo total de energía del mes en curso.',
    TotalEnergyConsumption: 'Consumo total de energía',
    TotalEnergyConsumptionContent: 'Consumo totalizado de los contadores',
    EnergyConsSelectedPeriodContent: 'Consumo de energía Período seleccionado',
    DataQuality: 'Calidad de los datos',
    BaselineQuality: 'Calidad de referencia',
    PowerDemand: 'Demanda de energía',
    APPLYBASELINEFROMDATEINVALID:
      'Seleccione una fecha no anterior a los últimos 15 días',
    INVALIDEXCLUSIONRANGESELECTION:
      'Seleccione una fecha de exclusión dentro del intervalo de fechas de formación seleccionado'
  },
  NILM: {
    NILMModalHeader: 'Inscribirse en NILM',
    NILMMeterDetails: 'Añadir detalles de NILM',
    SmartXMeter: 'Vista previa',
    NILMDetailsTabHeader:
      'Por favor, introduzca los detalles de su contador de Monitorización No Intrusiva de Carga (NILM) para añadirlos en HBSM',
    NILMDetailsTabSubHeader: 'Detalles del contador NILM',
    NILMMeterId: 'ID de datos/UUID',
    NILMDISAGGREGATEDMETERID: 'ID/UUID de datos desagregados (opcional)',
    NILMMeterName: 'Nombre del contador',
    NILMAddMeter: 'Añadir contador',
    NIMAssignMainMeter: 'Asignar como contador principal',
    NILMNextButton: 'Siguiente',
    NILMSubmitButtom: 'Enviar',
    NILMCancelButton: 'Cancelar',
    NILMcardheader: 'Control de carga no intrusivo (NILM)',
    NILMcardsubheader:
      'Determine el desglose del consumo energético de sus instalaciones por tipos de equipos',
    NILMRedirect: 'Será redirigido en 5 segundos',
    NILMAccountVerification: 'Verificación de cuenta en curso',
    NILMAccountVerificationSuccess:
      'Verificación de cuenta realizada con éxito',
    INVALIDNILMMETERID: 'ID de instalación de contador no válido',
    METERNAMEINVALID: 'el nombre del contador ya existe para el emplazamiento',
    NILMMainmeter: '(Asignado como contador principal)',
    NILMsmartXmeterheader:
      'A continuación se muestran sus contadores NILM. Por favor verifique para continuar y haga clic en enviar',
    NILMDUPLICATEMETERNAME: 'nombre de contador duplicado',
    NILMDUPLICATEMETERID: 'id duplicado del contador',
    IDDUPLICATETOGETHER: 'UUID inválido y duplicado',
    NAMEDUPLICATETOGETHER: 'nombre de contador ya existente y duplicado'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'Para el periodo de 12 meses que finaliza -',
    NoRecordsFound: 'No se han encontrado registros',
    LearnText: 'Más información',
    outOfHundred: '/100',
    CurrentScore: 'Puntuación actual',
    EnergyTooltipHeader: 'Uso de la energía',
    EnergyTooltipContent:
      'La puntuación Energy Star es una medida del rendimiento de su propiedad en relación con propiedades similares, cuando se normaliza en función del clima y las características operativas.',
    EnergyStarTitle: 'Puntuación Energy Star',
    loading: 'Cargando',
    ViewText: 'Ver detalles de la puntuación',
    SomethingWentWrong: 'Nota',
    notifyServerError:
      'Se ha producido un error en el servidor. Póngase en contacto con el administrador del sistema.',
    ReasonForNoScoreLabel:
      'La puntuación Energy Star no se ha podido cargar debido a algunos errores técnicos.',
    ViewReasonForNoScore:
      'Ver detalles del motivo de la ausencia de puntuación',
    EnergyStarNoScoreForLastMonthLabel:
      'No se ha podido cargar la puntuación Energy Star del mes anterior. Por lo tanto, la puntuación mostrada es del mes reciente.',
    EnergyStarNoScoreNoContentMessage:
      'No se ha encontrado la razón por la que no hay información de puntuación.'
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '"{fileName}" es un formato de archivo no válido. Sólo se acepta el formato de archivo .{extension}.',
    INVALIDFILE_EXTENSION:
      'Extensión de archivo no válida, utilice un archivo .{extension} válido.',
    INVALIDFILE_MIME:
      'Tipo mime de archivo no válido, Por favor, utilice un archivo con tipos mime válidos: {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE:
      'El tamaño del archivo debe ser inferior a {size}.',
    INVALIDFILE_MINALLOWEDSIZE:
      'El tamaño del archivo debe ser superior a {size}.',
    INVALIDFILE_UNKNOWNERROR:
      'Se ha producido algún error al acceder a la información del archivo. No se puede validar',
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'El archivo excel cargado tiene columnas no válidas. Por favor, utilice la plantilla adecuada y vuelva a cargar el archivo excel.',
    INVALID_SCHEMA_LIST_REQ_HEADERS:
      'Cabeceras requeridas: {requiredSubHeaders}',
    NO_DATA: 'El fichero no contiene datos',
    INVALID_DATA_CONTENT:
      'La primera fila de datos debe contener un elemento espacial',
    SOME_ERROR_EXCEL_READ:
      'Se ha producido un error al leer el archivo de Excel. Error: {errorString}',
    SOME_ERROR_GENERAL:
      'Se ha producido algún error. Vuelva a seleccionar y cargue un archivo válido. Detalles del error -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Tipo de datos no válido. Permitido: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'El nombre tiene un carácter especial no válido',
    NAME_INVALID_MAX_LEN: 'Máximo {len} caracteres permitidos',
    SPATIAL_ELE_NEW: 'Se creará una nueva área',
    NO_ASSOC_REMOVE:
      'No hay VAV / Sensor de Ocupación asignado. Por favor, elimine esta entrada',
    PROPERTIES_INVALID: 'Algunas propiedades no son válidas',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      'El Id. del elemento espacial proporcionado ({id}), el nombre de la hoja y el registrado en el sitio ({dbSpEleName}) no coinciden.',
    ELEMENT_NAME_MISMATCH:
      'El Id. del elemento proporcionado ({id}), el nombre de la hoja y el registrado en el sitio ({dbEleName}) no coinciden.',
    DUPLICATE_ENTRIES: 'Varias entradas con el mismo nombre',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'El sitio tiene varios equipos registrados con el mismo nombre. Por favor, cambie el nombre de este equipo a un nombre único para asociar',
    ELEMENT_ID_DNE: '{type} con Id proporcionado ({id}) no existe',
    SPATIAL_ELEMENT_ID_DNE: 'El área con el Id proporcionado ({id}) no existe',
    ELEMENT_TYPE_NAME_DNE: 'El {type} con este nombre no existe',
    PROPERTY_DNE: 'La propiedad con el nombre {name} no existe. Compruébelo'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO:
      'Asignación y configuración de espacios para equipos ZLO',
    UPLOAD_CARD_DESC_ZLO:
      'Cargar datos de asignación de equipos a espacios para la incorporación y configuración de ZLO',
    UPLOAD_MODAL_TITLE: 'Cargar datos de ZLO Onboarding',
    VALIDATE_DATA: 'Cargar',
    BACK_TO_UPLOAD: 'Volver',
    UPLOAD_TAB_TOP_NOTE:
      'Por favor, descargue la plantilla y rellene los detalles del Elemento Espacial junto con los detalles relacionados con el Equipo en la plantilla antes de proceder a la carga',
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Descargar plantilla XLSX',
    UPLOAD_TAB_SECOND_NOTE: '(Sólo es posible una carga a la vez)',
    UPLOAD_TAB_PLACEHOLDER: 'Arrastre y suelte un archivo aquí',
    VALIDATING_FILE_DATA: 'Validación de los datos del archivo',
    READING_FILE: 'Lectura del archivo',
    VALIDATING_FILE_SCHEMA: 'Validación del esquema del archivo',
    RETRIEVING_SITE_DATA: 'Recuperación de datos del sitio para su validación',
    VALIDATING_DATA_ENTRIES: 'Validación de datos',
    ALL_ENTRIES_VALID: 'Todas las entradas son válidas',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Haga clic en enviar para continuar y registrarse en HBSM',
    VIEW_ALL_ENTRIES: 'Ver todas las entradas',
    FIX_VAL_ERRORS_MSG:
      'A continuación se muestran las entradas erróneas de ZLO Onboarding y Datos de Configuración. Por favor, vuelva a la pestaña de carga y vuelva a cargar Excel sin las entradas erróneas para registrarse en HBSM.',
    VAL_OK_SUBMIT_MSG:
      'Por favor, haga clic en enviar para continuar y registrarse en HBSM',
    ERROR_BOX_TEXT:
      '{numErrors} errores identificados. Por favor, rectifíquelos y vuelva a cargar el archivo para enviarlo y registrarse en HBSM.',
    VALIDATION_ERROR_TITLE: 'Error en Validación',
    TOTAL: 'Total',
    CURRENTLY_SHOWING: 'Mostrando {num} de {total} Total',
    SHOW_ALL_ENTRIES: 'Mostrar todas las entradas',
    SL_NO: 'Sl. No',
    SPATIAL_ELE_NAME: 'Nombre del elemento espacial',
    ELE_TYPE: 'Tipo de elemento',
    ELE_NAME: 'Nombre',
    ZLO_STATE: 'Estado ZLO',
    ZO_SETBACK: 'Retroceso de optimización de zona (F)',
    VAV: 'Volumen de aire variable',
    OCCUPANCY_SENSOR: 'Sensor de ocupación',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'Sensor de ocupación',
    SEARCH_PLACEHOLDER: 'Buscar en',
    SEARCH_MIN_LEN: 'Min {len} Caracteres',
    NO_DATA: 'Ningún dato coincide con su búsqueda',
    VALIDATING_TITLE: 'Validación del archivo cargado',
    SOME_ERROR_FETCHING_DATA:
      'Se ha producido un error al obtener los datos del sitio. Error: {errorString}',
    SUBMITTING_TITLE:
      'Por favor, espere mientras asignamos el equipo al espacio',
    SUBMITTING_SUBTITLE: 'Será redirigido en unos segundos',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Crear nuevos espacios',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS: 'Mapeando Equipos a Espacios',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      'Algún Error en Mapear elemento a elemento espacial. Vuelva a intentarlo más tarde',
    UPDATING_PROPERTIES: 'Actualizando Propiedades',
    SUBMISSION_SUCCESS_TITLE: 'El Mapeo de Equipos a Espacios fue Exitoso',
    SUBMISSION_ERROR_TITLE: 'Error al enviar datos',
    SUBMISSION_ERROR_MESSAGE:
      'Error al enviar los datos. Vuelva a intentarlo más tarde',
    BULK_CREATION_ERROR_MESSAGE:
      'Se ha producido un error al crear elementos espaciales. Vuelva a intentarlo más tarde.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Se ha producido un error al actualizar las propiedades. Vuelva a intentarlo más tarde.',
    SUBMISSION_SUCCESS_SUBTITLE:
      'Los sensores VAV y de ocupación asignados a los espacios se reflejarán en la pestaña de equipos de la página de inicio del sitio.',
    GOTO_SITE_HOME_PAGE: 'Ir a la página de inicio',
    'Items per Page': 'Filas por página'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'La siguiente información se muestra siempre según el ciclo de información de facturación'
  },
  UtilityBuilder: {
    NEWBILL: 'Nueva factura',
    ENTERDATAMANUALLY: 'Introducir datos manualmente',
    BILLNAME: 'Nombre de la factura',
    BILLINGDATE: 'Fecha de facturación',
    TOTAL_BILL_AMOUNT: 'Monto total de la factura',
    BILLING_PERIOD_CONSUMPTION: 'Consumo del periodo de facturación',
    BILLING_DEMAND: 'Demanda de facturación',
    ENTER_PLACEHOLDER: 'Entrar',
    SELECT_PLACEHOLDER: 'Seleccionar',
    CATEGORIES: 'Categorías',
    ACCOUNTNUMBER: 'Número de cuenta',
    UTILITYTYPE: 'Tipo de servicio',
    BILLINGCYCLE: 'Ciclo de facturación',
    UPLOADELECTRICITYBILL: 'Cargar factura de electricidad',
    UPLOADGASBILL: 'Cargar factura de gas',
    ADDELECTRICITYBILL: 'Añadir factura de electricidad',
    ADDGASBILL: 'Añadir {utilityType} Factura',
    UPLOADUTILITYBILL: 'Cargar factura',
    PDFUPLOADPROMPT: 'Por favor, cargue un archivo PDF de la factura',
    UploadElectricitybill: 'Cargar factura de electricidad',
    Utilitybill: 'Factura de electricidad',
    UPLOADBILL: 'Subir {utilityType} Factura',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Cargar factura de electricidad',
    FILENAMECONTAINSPACES: 'El nombre del archivo contiene espacios.',
    FILENAMECONTAINSPECIALCHARACTER:
      'El nombre del archivo contiene caracteres especiales.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Categorías de facturas',
    REFERSAMPLEBILL: 'consulte la factura de muestra.',
    INPUTCATEGORIES:
      'Por favor, introduzca las diferentes categorías y los costes correspondientes de su factura de {utilityType}. Si necesita ayuda para localizarlos en la factura,'
  },
  baseline: {
    baselineconfiguration: 'Configuración de la línea de base',
    baselineConfigDesc:
      'Las líneas de base ajustadas establecen el consumo esperado de la utilidad para un sitio, basándose en una combinación de consumo histórico, tendencias recientes e impactos conocidos como variables meteorológicas.',
    baseline: 'Línea de base',
    total: 'Total',
    searchPlaceholder: 'Buscar',
    create: 'Crear línea de base',
    view: 'Ver línea de base',
    baselineQuality: 'Calidad de la línea de base',
    baselinePeriod: 'Período de referencia',
    reportingPeriod: 'Período de referencia',
    estBaselinePeriod: 'Establecer período base',
    baselinePeriodDescription:
      'Seleccione el periodo base y el periodo de informe para el que necesita crear la línea base',
    independentVariables: 'Variables independientes',
    autoSelectBest: 'Seleccione automáticamente las mejores variables',
    utilityDataType: 'Tipo de datos de utilidad',
    calendarMonth: 'Mes natural',
    billingPeriod: 'Periodo de facturación',
    tStat: 'T-Stat'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'AÑADIR CUENTA',
    ADD_METERS: 'AÑADIR CONTADORES'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Monto total de la factura',
  Consumption: 'Consumo',
  Demand: 'Demanda',
  'Service Charges': 'Cargos por servicio',
  'Transmission & Distribution': 'Transmisión y distribución',
  Others: 'Otros',
  'Demand Charges': 'Cargos por demanda',
  'Total Cost': 'Costo total',
  Total: 'Total'
};
